import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NexsysMonitorService, OriginSourceData } from '../../service/nexsys-monitor.service';
import { Store } from '@ngxs/store';
import { ORIGIN, SUBURLS, URLS } from '../model/nexsys-monitor.constant';
import { SetOrderMonitorOrigin } from '../state/actions/nexsys-monitor.actions';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Secure } from '@cv-invision/core';
import { PERMISSION } from '../../model/global-configuration.constant';
import { ValueLinkMonitorService } from '../../service/value-link.service';

@Component({
	selector: 'cv-nexsys-monitor-header',
	templateUrl: './nexsys-monitor-header.component.html',
	styleUrls: ['./nexsys-monitor-header.component.scss']
})
export class NexsysMonitorHeaderComponent implements OnInit, OnDestroy {
	nexsysOrderId: string;
	xpanseTransactionId: string;
	headerSubtitle: string;
	showBackLink: boolean;
	originSelected: string;
	mainURL: string;
	origin: string;
	originRedirect: string;
	originList: Array<string>;
	btnText: string;
	canSearch: boolean;
	placeholderInput: string;
	placeholderInputTransactionId: string;
	noReload: boolean;
	clearSourceSelected: boolean;
	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private route: ActivatedRoute,
		private store: Store,
		private router: Router,
		private nexsysMonitorService: NexsysMonitorService,
		private valueLinkService: ValueLinkMonitorService,
		private location: Location
	) {
		this.showBackLink = false;
		this.originList = [];
	}

	ngOnInit(): void {
		this.addNexsysOrigin();
		this.addNexsysOrphanOrigin();
		this.addValutrustOrigin();
		this.addXpanseOrigin();
		this.addOrderExternalOrigin();
		this.addFNCOrigin();
		this.addEVOOrigin();
		this.addValueLink();
		this.addValueLinkLender();
		this.addConnexions();
		this.addLendingQB();
		this.addLandGorilla();
		this.addFics();
		this.addLendingpad();

		if (this.originList.length) {
			this.origin = this.originList[0];
		}

		const url = this.router.url;
		Object.keys(URLS).forEach(urlKey => {
			if (url.includes(URLS[urlKey])) {
				const key = Object.keys(ORIGIN).find(originKey => {
					const pattern = /[^a-zA-Z0-9]/gm;
					const cleanUrlKey = urlKey.toLowerCase().replace(pattern, '');
					const cleanOriginKey = (ORIGIN[originKey as keyof typeof ORIGIN] || '')
						.toLowerCase()
						.replace(pattern, '');

					return cleanOriginKey === cleanUrlKey;
				});

				if (key) {
					this.origin = ORIGIN[key];
					this.mainURL = URLS[urlKey];
					this.placeholderInput = `${this.origin} OrderId`;
					this.placeholderInputTransactionId = '';

					switch(this.mainURL) {
						case URLS.XPANSE:
							this.placeholderInput = `${this.origin} SPN ID`;
							this.placeholderInputTransactionId = `${this.origin} Transaction ID`;
							break;

						case URLS.ORDER_EXTERNAL:
							this.placeholderInput = `${this.origin} SPN ID`;
							this.placeholderInputTransactionId = `Class order Id`;
							break;
					}
				}
			}
		})

		if (this.router.url && this.router.url.includes(SUBURLS.LOGS)) {
			this.headerSubtitle = 'Callback Logs ';
			this.originRedirect = SUBURLS.LOGS;
		}

		if (this.router.url && this.router.url.includes(SUBURLS.ORDERS)) {
			this.headerSubtitle = 'Orders';
			this.originRedirect = SUBURLS.ORDERS;
		}

		if (this.router.url && this.router.url.includes(SUBURLS.ORDERLOGS)) {
			this.headerSubtitle = 'Order Logs ';
			this.originRedirect = SUBURLS.ORDERLOGS;
			this.showBackLink = true;
		}

		this.originSelected = this.origin;
		this.canSearch = !!this.originSelected;
		this.btnText = `${this.origin} Order log`;
		this.nexsysMonitorService
			.getReloadListListener()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data: OriginSourceData) => {
				if (data.isHeaderChange) {
					this.origin = data.origin;
					this.clearSourceSelected = this.origin ? false : true;
					this.originSelected = data.origin;

					if (this.originSelected === ORIGIN.Xpanse) {
						this.placeholderInput = `${this.originSelected} SPN ID`;
						this.placeholderInputTransactionId = `${this.originSelected} Transaction ID`;
					}

					this.canSearch = !!this.originSelected;
					this.btnText = `${this.origin || ''} Order log`;
					this.placeholderInput = `${this.origin || ''} OrderId`;
				}
			});
	}

	@Secure(PERMISSION.NEXSYS)
	private addNexsysOrigin(): void {
		this.originList.push(ORIGIN.Nexsys);
	}

	@Secure(PERMISSION.NEXSYS_ORPHAN)
	private addNexsysOrphanOrigin(): void {
		if (this.router.url && !this.router.url.includes(SUBURLS.ORDERS) && !this.router.url.includes(SUBURLS.ORDERLOGS)) {
			this.originList.push(ORIGIN.NexsysLegacy);
		}
	}

	@Secure(PERMISSION.VALUTRUST)
	private addValutrustOrigin(): void {
		this.originList.push(ORIGIN.Valutrust);
	}

	@Secure(PERMISSION.XPANSE)
	private addXpanseOrigin(): void {
		this.originList.push(ORIGIN.Xpanse);
	}

	@Secure(PERMISSION.FNC)
	private addFNCOrigin(): void {
		this.originList.push(ORIGIN.FNC);
	}

	@Secure(PERMISSION.EVO)
	private addEVOOrigin(): void {
		this.originList.push(ORIGIN.EVO);
	}

	@Secure(PERMISSION.ORDERS_EXTERNAL)
	private addOrderExternalOrigin(): void {
		if (this.router.url && !this.router.url.includes(SUBURLS.ORDERS)) {
			this.originList.push(ORIGIN.OrderExternal);
		}
	}

	@Secure(PERMISSION.VALUELINK)
	private addValueLink(): void {
		this.originList.push(ORIGIN.ValueLink);
	}

	// @Secure(PERMISSION.VALUELINK_LENDER)
	private addValueLinkLender(): void {
		this.originList.push(ORIGIN.ValueLinkLender);
	}

	@Secure(PERMISSION.CONNEXIONS)
	private addConnexions(): void {
		this.originList.push(ORIGIN.Connexions);
	}

	@Secure(PERMISSION.LENDING_QB)
	private addLendingQB(): void {
		this.originList.push(ORIGIN.Lendingqb);
	}

	@Secure(PERMISSION.LANDGORILLA)
	private addLandGorilla(): void {
		this.originList.push(ORIGIN.LandGorilla);
	}

	@Secure(PERMISSION.FICS)
	private addFics(): void {
		this.originList.push(ORIGIN.Fics);
	}

	// @Secure(PERMISSION.LENDINGPAD)
	private addLendingpad(): void {
		this.originList.push(ORIGIN.LendingPad);
	}

	/**
	 * search order by Nexsys orderID
	 */
	onSearchOrder(): void {
		if (this.nexsysOrderId) {
			this.router.routeReuseStrategy.shouldReuseRoute = () => false;
			this.router.onSameUrlNavigation = 'reload';
			if (!this.mainURL) {
				this.onOriginSelected(this.originSelected);
			}

			if (this.origin === ORIGIN.Xpanse) {
				if (this.xpanseTransactionId) {
					this.router.navigate(
						[`/global-configuration/${this.mainURL}/order-log/`, this.xpanseTransactionId, this.nexsysOrderId],
						{
							relativeTo: this.route,
							queryParamsHandling: 'preserve'
						}
					);
				}
			} else if (this.origin === ORIGIN.ValueLink) {
				this.router.navigate(
					[`/global-configuration/${this.mainURL}/logs`],
					{
						relativeTo: this.route,
						queryParamsHandling: 'preserve'
					}
				);
			} else {
				this.router.navigate(
					[`/global-configuration/${this.mainURL}/order-log/`, this.nexsysOrderId],
					{
						relativeTo: this.route,
						queryParamsHandling: 'preserve'
					}
				);
			}
		}
	}

	/**
	 * set origin source
	 */
	onOriginSelected($event: any): void {
		this.canSearch = !!$event;
		this.btnText = `${$event || ''} Order log`;
		this.placeholderInput = `${$event || ''} OrderId`;
		if ($event) {
			this.clearSourceSelected = false;
			this.store.dispatch(new SetOrderMonitorOrigin($event));

			Object.keys(ORIGIN).forEach(originKey => {
				if ($event === ORIGIN[originKey]) {
					const foundKey = Object.keys(URLS).find(urlKey => {
						const pattern = /[^a-zA-Z0-9]/gm;
						const cleanOriginKey = originKey.toLowerCase().replace(pattern, '');
						const cleanUrlKey = urlKey.toLowerCase().replace(pattern, '');

						return cleanOriginKey === cleanUrlKey;
					});

					if (foundKey) {
						this.mainURL = URLS[foundKey];

						switch(ORIGIN[originKey]) {
							case ORIGIN.Xpanse:
								this.placeholderInput = `${$event} SPN ID`;
								this.placeholderInputTransactionId = `${$event} Transaction ID`;
								break;
						}
					}
				}
			})

			if (this.originRedirect === SUBURLS.LOGS && this.origin !== $event) {
				this.router.navigate([`global-configuration/${this.mainURL}/logs`]);
			}
			if (this.originRedirect === SUBURLS.ORDERS && (this.origin || this.origin !== $event)) {
				this.nexsysMonitorService.reloadList({ isDirty: true, origin: $event });
			}
			this.origin = $event;
		}
	}

	/**
	 * Go back
	 */
	goBack(): void {
		this.location.back();
	}

	/**
	 * Calls service to communicate with Inbox component to reload the grid.
	 */
	reloadList(): void {
		this.nexsysMonitorService.reloadList({ reload: true });
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.unsubscribe();
		this.nexsysMonitorService.reloadList(
			{
				reload: false,
				isDirty: false,
				isHeaderChange: false,
				origin: null
			});
		this.originList = [];
	}
}
